<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name 外出手段の選択肢
        slot(name="question")

    b-form-checkbox-group(v-model="_value"
        :options="_useVehicleOptions"
        value-field="item"
        text-field="name"
        size="lg"
        :data-vv-as="name")

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { UseVehicleOptions } from "@/commons/services/OutingSettings";

@Component({})
export default class InputUseVehicleOptionss extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: UseVehicleOptions;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /**
   * ### 親コンポーネントから渡されたUseVehicleOptionsのプロパティから文字列配列を返す
   *
   * - 各プロパティで、trueのものがあればプロパティ名を返却用配列に格納する
   */
  get _value(): string[] {
    const useVehicleOptions: string[] = [];
    for (const key in this.value) {
      if (this.value[key] === true) {
        useVehicleOptions.push(key);
      }
    }
    return useVehicleOptions;
  }

  /**
   * ### 親コンポーネントに文字列配列からUseVehicleOptionsを作成して返す
   *
   * - 入力された文字列配列はUseVehicleOptionsのプロパティ名になっている
   */
  set _value(selectedOptions: string[]) {
    // まず初期化
    for (const key in this.value) {
      this.value[key] = false;
    }
    // 文字列配列はプロパティ名を指しているので、文字列配列にあるものはtrueを設定する
    for (const day of selectedOptions) {
      this.value[day] = true;
    }
    this.$emit("input", this.value);
    return;
  }

  get _useVehicleOptions(): Array<{ item: string; name: string }> {
    return [
      { item: "familyCar", name: "家族等の車" },
      { item: "facilityCar", name: "施設の車" },
      { item: "taxi", name: "タクシー" }
    ];
  }
}
</script>
